import { Component, h, getMode, Host, Prop } from '@stencil/core';

@Component({
  tag: 'ds-search-fly-out',
  styleUrls: {
    default: 'ds-search-fly-out.scss',
    light: 'ds-search-fly-out.scss'
  },
  shadow: true
})
export class FlyOut {
  @Prop({ reflect: true }) type?: 'masthead' | 'menu' = 'masthead';
  render() {
    return (
      <Host data-mode={getMode(this)}>
        <div class={{ 'search-fly-out': true, 'search-fly-out--desktop': this.type !== 'menu' }}>
          <ds-custom-scrollbar class='search-fly-out__scrollbar'>
            <div>
              <slot name='search-title'></slot>
              <slot name='search-results'></slot>
            </div>
          </ds-custom-scrollbar>
        </div>
      </Host>
    );
  }
}
